import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import { Select } from 'rmwc/Select';
import {Button} from 'rmwc/Button';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import PaginationComponent from '../PaginationComponent';


class AdminPurchaseOrderView extends Component {

  constructor(props){
    super(props);
    this.state = {
      data: {
        purchaseOrders: [],
        overallCount: 0,
      },
      page: 1,
      limit: 20,
      showPurchaseDetail: false,
      selectedPurchaseorder: ''
    }
  }

  componentDidMount(){
    this.fetchAdminPODetails(1)
  }

  handleShowPODetails = (e, po) => {
    e.preventDefault()
    this.setState({showPurchaseDetail: true, selectedPurchaseorder: po})
  }

  handleShowParent = (e) => {
    e.preventDefault()
    this.setState({selectedPurchaseorder:'', showPurchaseDetail:false})
  }

  handlePaginationChange = (pageNo) => {
    this.fetchAdminPODetails(pageNo)
  }

  fetchAdminPODetails(pageNo){
    let data = Object.assign({}, this.state.data)
    api.getAdminPurchaseOrderList(this.props.user.accessToken, pageNo, this.state.limit)
      .then((result) => {
        if(result.status === 'success') {
          data.purchaseOrders = result.data
          data.overallCount = result.count
          this.setState({data:data})
        }
    })
  }

  render() {

    let purchaseOrdersListComp
    let handleShowPODetails = this.handleShowPODetails
    let backButtonComponent
    let paginationKey = this.state.data.overallCount
    let paginationFlag = this.state.showPurchaseDetail
 
    if(this.state.data.purchaseOrders.length > 0){

      if(this.state.showPurchaseDetail){
        purchaseOrdersListComp = (<div key={this.state.selectedPurchaseorder.purchase_order_id}> <AdminPurchaseOrderDetailView accessToken={this.props.user.accessToken} po={this.state.selectedPurchaseorder}/> </div>)
        backButtonComponent =  <Button dense onClick={((e) => this.handleShowParent(e))}>Back</Button>
      }



      else{
        purchaseOrdersListComp = <table className="myRegistrationTable">
          <th>Purchase Id</th>
          <th>User Id</th>
          <th>Ordered On</th>
          <th>Amount</th>
          <th>Payment Status</th>
          <th>Item Count</th>
          <tbody>
         
          {this.state.data.purchaseOrders.map(function(po) {
            return (
              <tr>
                <td>#{po.purchase_order_id}</td>
                <td>{po.user_id}</td>
                <td>{po.created_at}</td>
                <td>{po.payment_final_amount}</td>
                <td>{po.payment_status}</td>
                <td><Button onClick={((e) => handleShowPODetails(e, po))}>{po.total_purchase_items}</Button></td>
              </tr>
            )
            
          })}
          </tbody>
        </table>
      }
    }

    return(
      <Grid>
        <GridCell span="12">
          <Card style={{background:'white'}}>
             <Typography style={{margin:'10px', color:'black'}}use="subtitle">Purchase Order Admin View</Typography>
          </Card>
        </GridCell>
        <GridCell span="12">
          {backButtonComponent}
        </GridCell>
        <GridCell span="12">
          {purchaseOrdersListComp}
        </GridCell>
        <GridCell span="12">
          <div hidden={paginationFlag} key={paginationKey}>
            <PaginationComponent totalItems = {this.state.data.overallCount}
              itemsPerPage = {this.state.limit} 
              onHandleItemsFetch = {this.handlePaginationChange} />
          </div>
        </GridCell>
      </Grid>
      
    
    );
  }
}


class AdminPurchaseOrderDetailView extends Component {
  constructor(props){
    super(props);
    this.state={
      data: {
        purchase_order: '', 
        amount: 0,
        discount: 0, 
        final_amount: 0, 
        item_details: [],
      }
    }
  }

  componentDidMount() {
   let data = Object.assign({}, this.state.data)
    api.getAdminPurchaseOrderDetail(this.props.accessToken, this.props.po.purchase_order_id)
      .then((result) => {
        if(result.status === 'success') {
          data.purchase_order = result.data[0]
  
          if(data.purchase_order.status === 'Paid'){
            data.amount = data.purchase_order.payment_amount
            data.discount = data.purchase_order.payment_discount
            data.final_amount = data.purchase_order.payment_final_amount
            data.item_details = data.purchase_order.payment_item_details
          }
          else{
            data.amount = data.purchase_order.cart_amount
            data.discount = data.purchase_order.cart_discount
            data.final_amount = data.purchase_order.cart_final_amount
            data.item_details = data.purchase_order.cart_item_details
          }
         
          this.setState({data:data})
        }
      }) 
  }

  render(){
    
    let item_details_component
    let rowCount = 0
    item_details_component = <GridCell span="8">
    {this.state.data.item_details.map(function(item) {
      rowCount = rowCount + 1
      return <div> {rowCount}) {item.name} </div>

    })}
    </GridCell>
    return(
        <Grid style={{background:'white'}}>
          <GridCell span="2">
            <Typography use="subtitle">User Id</Typography>
          </GridCell>
          <GridCell span="4">
            <Typography use="subtitle">{this.props.po.user_id}</Typography>
          </GridCell>
          <GridCell span="2">
            <Typography use="subtitle">User Name</Typography>
          </GridCell>
          <GridCell span="4">
            <Typography use="subtitle">{this.props.po.user_name}</Typography>
          </GridCell>
          <GridCell span="2">
            <Typography use="subtitle">Email</Typography>
          </GridCell>
          <GridCell span="4">
            <Typography use="subtitle">{this.props.po.email}</Typography>
          </GridCell>
          <GridCell span="2">
            <Typography use="subtitle">Phone</Typography>
          </GridCell>
          <GridCell span="4">
            <Typography use="subtitle">{this.props.po.phone}</Typography>
          </GridCell>

          <GridCell span="2">
            <Typography use="subtitle">Order Id</Typography>
          </GridCell>
          <GridCell span="4">
            <Typography use="subtitle">#{this.props.po.purchase_order_id}</Typography>
          </GridCell>
          <GridCell span="2">
            <Typography use="subtitle">Count</Typography>
          </GridCell>
          <GridCell span="4">
            <Typography use="subtitle">{this.props.po.total_purchase_items}</Typography>
          </GridCell>

          <GridCell span="2">
            <Typography use="subtitle">Pmt Status</Typography>
          </GridCell>
          <GridCell span="4">
            <Typography use="subtitle">{this.props.po.payment_status}</Typography>
          </GridCell>
          <GridCell span="2">
            <Typography use="subtitle">Payment Id</Typography>
          </GridCell>
          <GridCell span="4">
            <Typography use="subtitle">{this.props.po.payment_id}</Typography>
          </GridCell>

          <GridCell span="2">
            <Typography use="subtitle">Purchase On</Typography>
          </GridCell>
          <GridCell span="4">
            <Typography use="subtitle">{this.state.data.purchase_order.created_at}</Typography>
          </GridCell>
          <GridCell span="2">
            <Typography use="subtitle">Amount</Typography>
          </GridCell>
          <GridCell span="4">
            <Typography use="subtitle">{this.state.data.amount}</Typography>
          </GridCell>

          <GridCell span="2">
            <Typography use="subtitle">Discount</Typography>
          </GridCell>
          <GridCell span="4">
            <Typography use="subtitle">{this.state.data.discount}</Typography>
          </GridCell>
          <GridCell span="2">
            <Typography use="subtitle">Final Amount</Typography>
          </GridCell>
          <GridCell span="4">
            <Typography use="subtitle">{this.state.data.final_amount}</Typography>
          </GridCell>
          
          <GridCell span="2">
            <Typography use="subtitle">Items</Typography>
          </GridCell>
          {item_details_component}


        </Grid>      
    )
  }


}


function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminPurchaseOrderView);


// WEBPACK FOOTER //
// ./src/views/admin/AdminPurchaseOrderView.jsx